import React from 'react';
import _ from 'lodash';
import { RepoItem } from '../../autogenerated/ZoomBridge';
import ErrorHandler from '../../error/ErrorHandler';
import ConciseAsset from '../../common/ConciseAsset';
import CollectionUtil from './../../queries/lightbox/CollectionUtil';
import Modal from '../Modal2';
import t from '../../i18n/I18n';
const debug = require('../../debug/debug')('wc:modals:DeleteAssetsModal');

type Props = {
  assets: RepoItem[],
  onClose: Function,
  onDeleteSuccess: Function
};

export default class RemoveAssetsModal extends React.Component<Props> {
  static defaultProps = {
    onDeleteSuccess: _.noop
  };

  render() {
    const { assets, onClose } = this.props;

    const modalProps = {
      name: 'RemoveAssetsModal',
      title: t('REMOVE_MODAL.TITLE_CONFIRM'),
      onClose,
      buttons: [
        { label: t('NO'), onClick: onClose, type: 'CANCEL' },
        { label: t('YES'), onClick: this.removeSelectedAssets, type: 'PRIMARY' }
      ]
    };

    const pluralized = assets.length === 1 ? t('ASSET').toLowerCase() : t('ASSETS').toLowerCase();

    return (
      <Modal {...modalProps} closeOnEsc closeOnOutsideClick>
         <div>{t('CONFIRM_REMOVE', {length: assets.length, word: pluralized})}</div>
        <div style={{ maxHeight: `${window.innerHeight - 250}px`, overflowY: 'auto', marginBottom: 30 }}>
          {assets.map((asset) => <ConciseAsset key={asset.getFuid()} style={styles.assetDisplay} asset={asset}/>)}
        </div>
      </Modal>
    );
  }

  removeSelectedAssets = () => {
    const { assets, onDeleteSuccess, onClose } = this.props;
    CollectionUtil.deleteCollectionAssets(window.ARGS.collectionId, assets)
      .then(() => {
        debug('[removeSelectedAssets()] success');
        onDeleteSuccess(assets);
        onClose(true);
      })
      .catch((error) => {
        debug('[removeSelectedAssets()] error: ', error);
        ErrorHandler.handleError(error == null ? t('REMOVE_MODAL.DELETE_FAILED') : error);
      });
  };
}

const styles = {
  assetDisplay: {
    marginTop: '0.5em'
  }
};
